import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const StandardLoadingIconContainer = styled("div")`
    z-index: 1;
    position: fixed;
    margin: -20vh 0;
    height: 140vh;
    background: white;
    display: flex;
    width: 985px;
    @media (max-width: ${breakpoints.values.xl}px) {
        width: 80vw;
    }

    @media (max-width: ${breakpoints.values.lg - 1}px) {
        width: 100vw;
        left: 0;
    }

    align-items: center;
    justify-content: center;

    img {
        margin-top: -60vh;
        width: 3rem;
        height: 3rem;
    }
`
export default StandardLoadingIconContainer
